import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=3c519b31&scoped=true&"
import script from "./DownloadApp.vue?vue&type=script&lang=js&"
export * from "./DownloadApp.vue?vue&type=script&lang=js&"
import style0 from "./DownloadApp.vue?vue&type=style&index=0&id=3c519b31&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c519b31",
  null
  
)

export default component.exports